"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _vue = _interopRequireDefault(require("vue"));
/**
 * 生成rule
 * @param validatorName 验证名字
 * @param trigger 类型 blur || change
 * @param required 是否必填
 * @returns {{trigger: *, message: string, required: *}}
 */
_vue.default.prototype.$ruler = function (validatorName) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    message: "\u8BF7".concat(trigger === 'blur' ? '输入' : '选择').concat(validatorName),
    trigger: trigger,
    required: required
  };
};